import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Asks the native app to reload its Home Screen widgets when the user's routines change, so a
// phase logged here is on the Today's Routine widget by the time they leave the app. Only loads
// in apps that ship the widgets component.
export default class extends BridgeComponent {
  static component = "widgets"

  reload() {
    this.send("reload")
  }
}
